import * as yup from 'yup';
import i18n from '../../app/i18n';

const SUPPORTED_FORMATS = ['image/jpg', 'image/jpeg', 'image/png'];
const boardSetupSchema = yup.object({
  logo: yup
    .mixed()
    .test('fileType', i18n.t('boardSetup:formValidation.invalidFile'), value =>
      value.name ? SUPPORTED_FORMATS.includes(value.type) : true,
    ),
  name: yup.string().required(i18n.t('boardSetup:formValidation.emptyName')),
  publicSlug: yup
    .string()
    .required(i18n.t('boardSetup:formValidation.emptyBoardUrl')),
  employeeIdHeader: yup.string().when('useEmployeeId', {
    is: true,
    then: yup
      .string()
      .required(i18n.t('boardSetup:formValidation.emptyEmployeeIdHeader')),
    otherwise: yup.string(),
  }),
  employeeIdBody: yup.string().when('useEmployeeId', {
    is: true,
    then: yup
      .string()
      .required(i18n.t('boardSetup:formValidation.emptyEmployeeIdBody')),
    otherwise: yup.string(),
  }),
  useEmployeeId: yup.boolean(),
  hideWelcomeModalSignIn: yup.boolean(),
  guestUserConversionModal: yup.boolean(),
});

export default boardSetupSchema;
